<div class="wrapper">
    <div class="row">
        <div class="col-12">
            <h1 class="pageTitle">Cookies</h1>
            <p>Cookies are small text files that may be placed on your computer when you visit a website. They are
                widely used to
                make websites work and to make them more efficient. Cookies also help website owners understand how you
                use the site
                so that they can make it easier to find what you’re looking for.
            </p>
            <p>
                This website only uses <strong>strictly necessary cookies</strong>.
            </p>
            <h2>Strictly necessary cookies</h2>
            <p>These cookies are needed to make our website work.</p>

            <div class="table-responsive">
                            <table class="table table-striped table-bordered border-dark">
                <caption class="visually-hidden">List of Cookies</caption>
            <thead>
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Purpose</th>
                    <th scope="col">Expires</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>bbsidCOUNCIL</td>
                    <td>It stores a unique identifier for each visit to retain session state across multiple pages. This cookie is essential for the booking system.</td>
                    <td>Session</td>
                </tr>
            </tbody>
            </table>
            </div>


        </div>
    </div>

    <div class="row mt-4">
        <div class="col-6">
            <button type="button" class="btn btn-primary govuk-button button-sizer" (click)="routerGoBack()" title="Back"><span>
                    <fa-icon [icon]="faChevronLeft"></fa-icon><span>Back</span>
                </span>
            </button>
        </div>
    </div>
    <br>
</div>